var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserDummy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.4,
    height: 12,
    viewBox: "0 0 10.4 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-line",
    transform: "translate(-5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M13.8,8.6A2.8,2.8,0,1,0,11,5.8,2.8,2.8,0,0,0,13.8,8.6Zm0-4.8a2,2,0,1,1-2,2A2,2,0,0,1,13.8,3.8Z",
    transform: "translate(-3.6)",
    fill: "#0d3148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M15.188,21.15a6.864,6.864,0,0,0-9.972,0A.8.8,0,0,0,5,21.7v2.1a.8.8,0,0,0,.8.8h8.8a.8.8,0,0,0,.8-.8V21.7A.8.8,0,0,0,15.188,21.15ZM14.6,23.8H5.8V21.694a6.068,6.068,0,0,1,8.8,0Z",
    transform: "translate(0 -9.602)",
    fill: "#0d3148"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserDummy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user_dummy.1a0dff0d20d6c074c83ca332652645d5.svg";